import './PaymentMethodSelector.css';
import React, { useState, useEffect, useMemo } from 'react';
import { usePayPal } from 'Hooks/usePayPal';
import { PaymentTypeButton } from 'Features/PaymentMethodSelector/PaymentSelector/PaymentTypeButton';
import { isApplePayAvailable } from 'Api/ApplePay';
import { useStore } from 'Hooks/useStore';

export const PAYMENT_METHODS = {
  CARD: 'direct credit card',
  PAYPAL: 'paypal',
  APPLE: 'apple pay',
  COUPON: 'coupon',
};

export const PaymentMethodSelector = ({ selectedPaymentMethod, setPaymentMethod, setErrorMessage }) => {
  const currentPaymentMethods = useStore('paymentMethods');
  const { hasCardPayment, hasPaypalPayment, hasApplePayPayment } = currentPaymentMethods;
  const editMode = [hasCardPayment, hasPaypalPayment, hasApplePayPayment].includes(true);
  const purchaseMode = useStore('purchaseMode');
  const { isChangePlan } = purchaseMode;
  const [isPayPalEnabled] = usePayPal();
  const isApplePayCompatible = useMemo(() => isApplePayAvailable(), []);
  const [isSelected, setIsSelected] = useState(PAYMENT_METHODS.CARD);
  const getCurrentPaymentType = () => {
    if (hasCardPayment) return PAYMENT_METHODS.CARD;
    if (hasPaypalPayment) return PAYMENT_METHODS.PAYPAL;
    if (hasApplePayPayment) return PAYMENT_METHODS.APPLE;
  };
  const currentPaymentType = getCurrentPaymentType();
  useEffect(() => {
    if (editMode) {
      setPaymentMethod(currentPaymentType);
      setIsSelected(currentPaymentType);
    }
  }, [currentPaymentType, editMode, setPaymentMethod]);

  const highlightSelection = (button) => {
    if (button === selectedPaymentMethod) return;
    setPaymentMethod(button);
    setErrorMessage(''); // remove form submission error if a different payment method is selected. NATCOM-465

    return setIsSelected(button);
  };

  const checkHighlight = (button) => {
    if (button !== isSelected) return null;
    return 'selected';
  };

  return (
    <div className="selectPaymentMethodContainer">
      <hr className="sectionLine top" />
      <div className="paymentButtonsContainer">
        <PaymentTypeButton
          button={PAYMENT_METHODS.CARD}
          checkHighlight={checkHighlight}
          highlightSelection={highlightSelection}
        />
        {isPayPalEnabled && (
          <PaymentTypeButton
            button={PAYMENT_METHODS.PAYPAL}
            checkHighlight={checkHighlight}
            highlightSelection={highlightSelection}
          />
        )}
        {(isApplePayCompatible.deviceEnabled || hasApplePayPayment) && (
          <PaymentTypeButton
            fullWidth={isChangePlan}
            button={PAYMENT_METHODS.APPLE}
            checkHighlight={checkHighlight}
            highlightSelection={highlightSelection}
          />
        )}
      </div>
      {!currentPaymentType && <hr className="sectionLine bottom" />}
    </div>
  );
};
